module.exports = __webpack_public_path__ + "img/instacash-logo-black.48b16939.svg";